import {
  defaultUiSizeForFormFactor,
  readBootstrapUiSize,
  type UiSize,
} from '../domain/settings'
import { classifyViewportRuntime } from './visualViewport'
import type { NativePlatform } from './nativeRuntime'

interface UiSizeBootstrapEnvironment {
  nativePlatform?: NativePlatform | null
  standalone: boolean
  storage?: Pick<Storage, 'getItem' | 'setItem'>
  userAgent: string
}

export function applyUiSize(size: UiSize, root: HTMLElement = document.documentElement): void {
  if (root.dataset.uiSize !== size) root.dataset.uiSize = size
}

export function initializeUiSize(
  environment: UiSizeBootstrapEnvironment,
  root: HTMLElement = document.documentElement,
): UiSize {
  const runtime = classifyViewportRuntime({
    nativePlatform: environment.nativePlatform,
    standalone: environment.standalone,
    userAgent: environment.userAgent,
  })
  const fallback = defaultUiSizeForFormFactor(runtime.formFactor)
  const size = readBootstrapUiSize(fallback, environment.storage)
  applyUiSize(size, root)
  return size
}
